export const RateAdminAdvanceRateBreadcrumb = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/advance-rate", label: "Advance Rate" },
];

export const CreateRateAdminAdvanceRateBreadcrumb = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/advance-rate", label: "Advance Rate" },
  { path: "", label: "Create Advance Rate" },
];

export const EditRateAdminAdvanceRateBreadcrumb = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/advance-rate", label: "Advance Rate" },
  { path: "", label: "Edit Advance Rate" },
];

export const ViewRateAdminAdvanceRateBreadcrumb = [
  { path: "/dashboard", label: "Dashboard" },
  { path: "/advance-rate", label: "Advance Rate" },
  { path: "", label: "View Advance Rate" },
];

export const RateTypeDD = [
  { id: 1, name: "Exclusive" },
  { id: 2, name: "Inclusive" },
];

// LOR (Length of Rental) Dropdown
export const lorDD = [
  { id: 1, name: "1 Day" },
  { id: 2, name: "2 Days" },
  { id: 3, name: "3 Days" },
  { id: 4, name: "4 Days" },
  { id: 5, name: "5 Days" },
  { id: 6, name: "6 Days" },
  { id: 7, name: "1 Week" },
  { id: 14, name: "2 Weeks" },
  { id: 21, name: "3 Weeks" },
  { id: 30, name: "1 Month" },
];

// Fixed values that will be auto-selected (using IDs)
export const FIXED_VALUES = {
  fkRateGroup: 3,
  fkNetworkId: 1, 
  rateOption: 1,
  fkRateTypeId: 1,
};

// Dropdown options for disabled fields
export const rateGroupDD = [
  { id: 3, name: "Standard" },
];

export const networksDD = [
  { id: 1, name: "Zoom Rates" },
];

export const rateOptionDD = [
  { id: 1, name: "Actual Rate" },
];

export const rateTypeDD = [
  { id: 1, name: "Exclusive" },
  { id: 2, name: "Inclusive" },
];

// Day indices for Per Day columns (1-6)
export const DAY_INDICES = [1, 2, 3, 4, 5, 6];

// Week labels for Per Week columns
export const WEEK_LABELS = ['1ST', '2ND', '3RD', '4TH'];

// LOR values for rate table columns
// Category | Base | Per Hour | Per Day (1,2,3,4,5,6) | Per Week (1ST,2ND,3RD,4TH) | Extra Day | Monthly (30 day)
export const LOR_VALUES = [
  "Base",
  "Per Hour",
  "Per Day 1", "Per Day 2", "Per Day 3", "Per Day 4", "Per Day 5", "Per Day 6",
  "Per Week BASE", "Per Week Extra Days", "Per Week 1ST", "Per Week 2ND", "Per Week 3RD", "Per Week 4TH",
  "Extra Day",
  "Monthly (30 day)"
];


